import React from "react";
import { Container } from "react-bootstrap";
import VectorLine from "./VectorLine";
import zur from "../assets/image/png/zur.png";
import Cube_Other_perpective from "../assets/image/png/Cube Other perpective.png";

const Zusammenarbeit = () => {
  return (
    <>
      <section className=" py-5 mb-5">
        <Container>
          <p
            data-aos="fade-right"
            data-aos-offset="200"
            data-aos-easing="ease-in-sine"
            className=" comman_par text-center"
          >
            {" "}
            <span>
              {" "}
              <VectorLine />{" "}
            </span>{" "}
            Zusammenarbeit mit Consaltex
          </p>
          <h2
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            className=" comman_heading text-light text-center"
          >
            In 6 Schritten von der Agentur zur Umsatzmaschine
          </h2>

          <div className=" position-relative mt-5">
            <img
              src={Cube_Other_perpective}
              alt="Cube_Other_perpective"
              className=" position-absolute Cube_perpective d-none d-lg-inline-block"
            />
            <div
              data-aos="zoom-in-down"
              data-aos-offset="800"
              data-aos-Duration="500"
              className=" text-center"
            >
              <img src={zur} alt="zur" className=" d-none d-lg-inline-block" />
            </div>
            <div
              data-aos="fade-right"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
              className=" location_setup"
            >
              <div className=" d-flex align-items-lg-center hover_text">
                <svg
                  className="svg_hover d-lg-none"
                  width="127"
                  height="126"
                  viewBox="0 0 127 126"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_207_96)">
                    <circle
                      cx="63.4305"
                      cy="63.0701"
                      r="62.7967"
                      fill="#EA2663"
                      fill-opacity="0.15"
                    />
                  </g>
                  <g clip-path="url(#clip0_207_96)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M63.0154 35.4068C49.6486 36.9298 40.3398 50.5957 44.3934 62.7451C45.9773 67.4917 48.5271 71.0886 57.6932 81.5054C60.7205 84.9458 62.7204 87.3815 64.0609 89.2603C65.024 90.6105 65.302 90.8181 65.7515 90.5235C66.0698 90.315 66.1634 90.2008 67.6356 88.2264C69.0345 86.3503 70.612 84.4709 74.6997 79.8106C84.4185 68.7301 87.1679 63.9883 87.4074 57.8942C87.9266 44.6857 76.2288 33.9012 63.0154 35.4068ZM67.7475 45.9885C71.959 46.7865 75.2945 49.9981 76.5312 54.4461C76.8564 55.6155 76.8264 58.7282 76.4779 59.9982C74.7517 66.2883 68.2126 69.8734 62.0247 67.9226C58.3506 66.7642 55.499 63.7762 54.4622 59.9982C54.1136 58.7282 54.0837 55.6155 54.4089 54.4461C56.1187 48.2962 61.5964 44.823 67.7475 45.9885ZM57.6971 85.6645C52.6108 87.383 51.831 91.0246 56.0786 93.2216C61.8449 96.2041 72.9729 95.5556 76.5263 92.0301C78.8302 89.7441 77.3611 87.0536 73.0116 85.5936L72.082 85.2815L71.8444 85.5643C70.8266 86.7753 68.6739 89.5136 68.1129 90.3108C67.0183 91.8661 65.9538 92.4721 64.8184 92.1862C64.1606 92.0206 63.7609 91.6383 62.8154 90.2703C62.4161 89.6927 61.811 88.8718 61.4708 88.4462C60.4938 87.2245 58.8717 85.3156 58.8075 85.3122C58.7753 85.3105 58.2756 85.4691 57.6971 85.6645Z"
                      fill="#D0D4D3"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_b_207_96"
                      x="-10.3662"
                      y="-10.7266"
                      width="147.593"
                      height="147.593"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_207_96"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_207_96"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_207_96">
                      <rect
                        width="59.8488"
                        height="59.8488"
                        fill="white"
                        transform="translate(35.5061 35.2661)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div className="max_width mt-5 mt-lg-0">
                  <h2 className=" fw-semibold fs_md ff_Montserrat h2_text  text-lg-end">
                    Positionierung
                  </h2>
                  <p className=" fw-normal fs_sm ff_Montserrat text-light max_width text-lg-end">
                    Finde die optimale Zielgruppe für dein Angebot, bei der du
                    als Experte höhere Preise abrufen kannst!
                  </p>
                </div>
                <svg
                  className="svg_hover ms-lg-4 d-none d-lg-inline-block"
                  width="127"
                  height="126"
                  viewBox="0 0 127 126"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_207_96)">
                    <circle
                      cx="63.4305"
                      cy="63.0701"
                      r="62.7967"
                      fill="#EA2663"
                      fill-opacity="0.15"
                    />
                  </g>
                  <g clip-path="url(#clip0_207_96)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M63.0154 35.4068C49.6486 36.9298 40.3398 50.5957 44.3934 62.7451C45.9773 67.4917 48.5271 71.0886 57.6932 81.5054C60.7205 84.9458 62.7204 87.3815 64.0609 89.2603C65.024 90.6105 65.302 90.8181 65.7515 90.5235C66.0698 90.315 66.1634 90.2008 67.6356 88.2264C69.0345 86.3503 70.612 84.4709 74.6997 79.8106C84.4185 68.7301 87.1679 63.9883 87.4074 57.8942C87.9266 44.6857 76.2288 33.9012 63.0154 35.4068ZM67.7475 45.9885C71.959 46.7865 75.2945 49.9981 76.5312 54.4461C76.8564 55.6155 76.8264 58.7282 76.4779 59.9982C74.7517 66.2883 68.2126 69.8734 62.0247 67.9226C58.3506 66.7642 55.499 63.7762 54.4622 59.9982C54.1136 58.7282 54.0837 55.6155 54.4089 54.4461C56.1187 48.2962 61.5964 44.823 67.7475 45.9885ZM57.6971 85.6645C52.6108 87.383 51.831 91.0246 56.0786 93.2216C61.8449 96.2041 72.9729 95.5556 76.5263 92.0301C78.8302 89.7441 77.3611 87.0536 73.0116 85.5936L72.082 85.2815L71.8444 85.5643C70.8266 86.7753 68.6739 89.5136 68.1129 90.3108C67.0183 91.8661 65.9538 92.4721 64.8184 92.1862C64.1606 92.0206 63.7609 91.6383 62.8154 90.2703C62.4161 89.6927 61.811 88.8718 61.4708 88.4462C60.4938 87.2245 58.8717 85.3156 58.8075 85.3122C58.7753 85.3105 58.2756 85.4691 57.6971 85.6645Z"
                      fill="#D0D4D3"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_b_207_96"
                      x="-10.3662"
                      y="-10.7266"
                      width="147.593"
                      height="147.593"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_207_96"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_207_96"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_207_96">
                      <rect
                        width="59.8488"
                        height="59.8488"
                        fill="white"
                        transform="translate(35.5061 35.2661)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div
              data-aos="fade-right"
              data-aos-offset="400"
              data-aos-easing="ease-in-sine"
              className=" Neukunden_setup"
            >
              <div className=" d-flex align-items-lg-center hover_text">
                <svg
                  className="svg_hover d-lg-none"
                  width="127"
                  height="127"
                  viewBox="0 0 127 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_119)">
                    <circle
                      cx="63.4999"
                      cy="63.4822"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <g clip-path="url(#clip0_1_119)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M82.0438 39.3197C75.658 40.6633 70.4105 41.7832 70.3827 41.8085C70.3548 41.834 71.8673 43.3905 73.7437 45.2676L77.1552 48.6804L73.7152 52.119C71.8232 54.0103 70.2988 55.5813 70.3276 55.6102C70.3565 55.639 75.5787 54.5912 81.9326 53.2819L93.4853 50.9012L90.0391 47.4532L86.5929 44.0051L90.1536 40.465C92.1121 38.518 93.7009 36.9141 93.6844 36.901C93.6679 36.8878 88.4296 37.9762 82.0438 39.3197ZM56.2389 40.4856L52.712 44.0138L57.4068 48.7075L62.1014 53.4012L65.6557 49.8457L69.21 46.2902L64.5445 41.6238C61.9787 39.0573 59.8537 36.9574 59.8226 36.9574C59.7913 36.9574 58.1787 38.5451 56.2389 40.4856ZM46.1438 50.5957C43.8489 52.9024 41.7448 55.0899 41.4682 55.4565C36.4058 62.1664 35.5234 70.8293 39.1481 78.2332C44.3754 88.9102 57.1841 93.3858 67.9094 88.2826C70.8851 86.8668 71.9726 85.9887 77.0437 80.9071L80.9875 76.955L76.298 72.2655L71.6085 67.5761L67.7433 71.4102C64.7451 74.3843 63.691 75.36 63.0447 75.76C59.6774 77.8438 55.4297 77.3455 52.6949 74.5457C51.0153 72.8265 50.3177 71.095 50.3303 68.6781C50.3457 65.7788 50.9397 64.6771 54.339 61.2435C55.6146 59.955 57.3566 58.1873 58.2099 57.3152L59.7614 55.7296L55.0983 51.0655C52.5336 48.5003 50.4085 46.4014 50.3759 46.4014C50.3432 46.4014 48.4388 48.2888 46.1438 50.5957ZM77.4601 61.7068L73.9332 65.235L78.628 69.9287L83.3226 74.6224L86.8769 71.0669L90.4312 67.5114L85.7657 62.845C83.1999 60.2785 81.0749 58.1786 81.0437 58.1786C81.0125 58.1786 79.3999 59.7663 77.4601 61.7068Z"
                      fill="#FCFFFE"
                      fill-opacity="0.8"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_b_1_119"
                      x="2.49988"
                      y="2.48218"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_119"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_119"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_1_119">
                      <rect
                        width="59.8488"
                        height="59.8488"
                        fill="white"
                        transform="translate(33.8357 33.5225)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div className="max_width mt-5 mt-lg-0">
                  <h2 className=" fw-semibold fs_md ff_Montserrat h2_text  text-lg-end">
                    Neukunden gewinnen
                  </h2>
                  <p className=" fw-normal fs_sm ff_Montserrat text-light max_width text-lg-end">
                    Gewinne verlässlich und berechenbar Neukunden, während du
                    dich auf dein Tagesgeschäft konzentrieren kannst!
                  </p>
                </div>
                <svg
                  className="svg_hover d-none d-lg-inline-block"
                  width="127"
                  height="127"
                  viewBox="0 0 127 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_119)">
                    <circle
                      cx="63.4999"
                      cy="63.4822"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <g clip-path="url(#clip0_1_119)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M82.0438 39.3197C75.658 40.6633 70.4105 41.7832 70.3827 41.8085C70.3548 41.834 71.8673 43.3905 73.7437 45.2676L77.1552 48.6804L73.7152 52.119C71.8232 54.0103 70.2988 55.5813 70.3276 55.6102C70.3565 55.639 75.5787 54.5912 81.9326 53.2819L93.4853 50.9012L90.0391 47.4532L86.5929 44.0051L90.1536 40.465C92.1121 38.518 93.7009 36.9141 93.6844 36.901C93.6679 36.8878 88.4296 37.9762 82.0438 39.3197ZM56.2389 40.4856L52.712 44.0138L57.4068 48.7075L62.1014 53.4012L65.6557 49.8457L69.21 46.2902L64.5445 41.6238C61.9787 39.0573 59.8537 36.9574 59.8226 36.9574C59.7913 36.9574 58.1787 38.5451 56.2389 40.4856ZM46.1438 50.5957C43.8489 52.9024 41.7448 55.0899 41.4682 55.4565C36.4058 62.1664 35.5234 70.8293 39.1481 78.2332C44.3754 88.9102 57.1841 93.3858 67.9094 88.2826C70.8851 86.8668 71.9726 85.9887 77.0437 80.9071L80.9875 76.955L76.298 72.2655L71.6085 67.5761L67.7433 71.4102C64.7451 74.3843 63.691 75.36 63.0447 75.76C59.6774 77.8438 55.4297 77.3455 52.6949 74.5457C51.0153 72.8265 50.3177 71.095 50.3303 68.6781C50.3457 65.7788 50.9397 64.6771 54.339 61.2435C55.6146 59.955 57.3566 58.1873 58.2099 57.3152L59.7614 55.7296L55.0983 51.0655C52.5336 48.5003 50.4085 46.4014 50.3759 46.4014C50.3432 46.4014 48.4388 48.2888 46.1438 50.5957ZM77.4601 61.7068L73.9332 65.235L78.628 69.9287L83.3226 74.6224L86.8769 71.0669L90.4312 67.5114L85.7657 62.845C83.1999 60.2785 81.0749 58.1786 81.0437 58.1786C81.0125 58.1786 79.3999 59.7663 77.4601 61.7068Z"
                      fill="#FCFFFE"
                      fill-opacity="0.8"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_b_1_119"
                      x="2.49988"
                      y="2.48218"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_119"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_119"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_1_119">
                      <rect
                        width="59.8488"
                        height="59.8488"
                        fill="white"
                        transform="translate(33.8357 33.5225)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div
              data-aos="fade-right"
              data-aos-offset="600"
              data-aos-easing="ease-in-sine"
              className="gewinnen_setup "
            >
              <div className=" d-flex align-items-lg-center hover_text">
                <svg
                  className="svg_hover d-lg-none "
                  width="128"
                  height="127"
                  viewBox="0 0 128 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_126)">
                    <circle
                      cx="63.7899"
                      cy="63.9644"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M77.5106 39.8349C77.1508 40.218 77.2385 40.5084 78.2343 42.2318C78.7505 43.1252 79.1729 43.8966 79.1729 43.9461C79.1729 43.9956 70.5596 49.8231 60.0321 56.896C49.5048 63.9689 40.8137 69.8455 40.7185 69.9552C40.335 70.3974 40.7002 71.2193 41.2802 71.2193C41.4174 71.2193 48.9213 67.6567 57.9556 63.3025C82.6675 51.3921 83.1673 51.1517 83.2607 51.1329C83.3084 51.1233 83.7935 51.8798 84.3386 52.8142C85.4215 54.6701 85.6136 54.86 86.1738 54.6279C86.3296 54.5634 86.5065 54.4135 86.567 54.2949C86.7068 54.0203 89.5459 43.4099 89.5459 43.1614C89.5459 42.6087 89.4057 42.5577 83.7182 41.0414C77.9578 39.5057 77.8413 39.483 77.5106 39.8349ZM75.5625 60.3973L75.32 60.6397V74.3806V88.1215L75.5625 88.364L75.805 88.6065H82.433H89.0609L89.3034 88.364L89.5459 88.1215V74.3806V60.6397L89.3034 60.3973L89.0609 60.1548H82.433H75.805L75.5625 60.3973ZM58.1754 68.3005L57.9328 68.543V78.3323V88.1215L58.1754 88.364L58.4178 88.6065H65.0458H71.6737L71.9162 88.364L72.1587 88.1215V78.3323V68.543L71.9162 68.3005L71.6737 68.058H65.0458H58.4178L58.1754 68.3005ZM40.7882 76.2038L40.5457 76.4462V82.2839V88.1215L40.7882 88.364L41.0306 88.6065H47.6586H54.2866L54.529 88.364L54.7715 88.1215V82.2839V76.4462L54.529 76.2038L54.2866 75.9613H47.6586H41.0306L40.7882 76.2038Z"
                    fill="#FCFFFE"
                    fill-opacity="0.8"
                  />
                  <defs>
                    <filter
                      id="filter0_b_1_126"
                      x="2.78992"
                      y="2.96436"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_126"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_126"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                <div className="max_width mt-5 mt-lg-0">
                  <h2 className=" fw-semibold fs_md ff_Montserrat h2_text  text-lg-end">
                    Neukunden gewinnen
                  </h2>
                  <p className=" fw-normal fs_sm ff_Montserrat text-light max_width text-lg-end">
                    Gewinne verlässlich und berechenbar Neukunden, während du
                    dich auf dein Tagesgeschäft konzentrieren kannst!
                  </p>
                </div>
                <svg
                  className="svg_hover d-none d-lg-inline-block"
                  width="128"
                  height="127"
                  viewBox="0 0 128 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_126)">
                    <circle
                      cx="63.7899"
                      cy="63.9644"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M77.5106 39.8349C77.1508 40.218 77.2385 40.5084 78.2343 42.2318C78.7505 43.1252 79.1729 43.8966 79.1729 43.9461C79.1729 43.9956 70.5596 49.8231 60.0321 56.896C49.5048 63.9689 40.8137 69.8455 40.7185 69.9552C40.335 70.3974 40.7002 71.2193 41.2802 71.2193C41.4174 71.2193 48.9213 67.6567 57.9556 63.3025C82.6675 51.3921 83.1673 51.1517 83.2607 51.1329C83.3084 51.1233 83.7935 51.8798 84.3386 52.8142C85.4215 54.6701 85.6136 54.86 86.1738 54.6279C86.3296 54.5634 86.5065 54.4135 86.567 54.2949C86.7068 54.0203 89.5459 43.4099 89.5459 43.1614C89.5459 42.6087 89.4057 42.5577 83.7182 41.0414C77.9578 39.5057 77.8413 39.483 77.5106 39.8349ZM75.5625 60.3973L75.32 60.6397V74.3806V88.1215L75.5625 88.364L75.805 88.6065H82.433H89.0609L89.3034 88.364L89.5459 88.1215V74.3806V60.6397L89.3034 60.3973L89.0609 60.1548H82.433H75.805L75.5625 60.3973ZM58.1754 68.3005L57.9328 68.543V78.3323V88.1215L58.1754 88.364L58.4178 88.6065H65.0458H71.6737L71.9162 88.364L72.1587 88.1215V78.3323V68.543L71.9162 68.3005L71.6737 68.058H65.0458H58.4178L58.1754 68.3005ZM40.7882 76.2038L40.5457 76.4462V82.2839V88.1215L40.7882 88.364L41.0306 88.6065H47.6586H54.2866L54.529 88.364L54.7715 88.1215V82.2839V76.4462L54.529 76.2038L54.2866 75.9613H47.6586H41.0306L40.7882 76.2038Z"
                    fill="#FCFFFE"
                    fill-opacity="0.8"
                  />
                  <defs>
                    <filter
                      id="filter0_b_1_126"
                      x="2.78992"
                      y="2.96436"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_126"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_126"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
            <div
              data-aos="fade-right"
              data-aos-offset="600"
              data-aos-easing="ease-in-sine"
              className="Vertrieb_setup "
            >
              <div className=" d-flex  hover_text">
                <svg
                  className=" svg_hover d-lg-none"
                  width="128"
                  height="127"
                  viewBox="0 0 128 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_133)">
                    <circle
                      cx="63.8353"
                      cy="63.7256"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <g clip-path="url(#clip0_1_133)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M53.7453 34.2216C53.4448 34.4644 53.4267 34.5732 53.3631 36.5131L53.2963 38.5496L52.1608 38.8521C50.7555 39.2262 49.0802 39.9272 47.8635 40.65L46.9389 41.1993L45.776 40.0099C43.7036 37.89 43.7593 37.8873 41.4366 40.2164C39.1424 42.5172 39.1583 42.3713 40.998 44.2382L42.4267 45.688L41.7601 46.8506C40.9616 48.2433 40.4871 49.3951 40.0806 50.928L39.7784 52.0675L37.7419 52.1343C35.0303 52.2233 35.1953 52.0156 35.1953 55.3404C35.1953 58.6652 35.0303 58.4575 37.7419 58.5465L39.7784 58.6133L40.0922 59.7962C40.464 61.1984 41.1391 62.8011 41.8913 64.0674L42.4357 64.9836L41.0024 66.4381C39.1576 68.3103 39.1417 68.163 41.4366 70.4644C43.7561 72.7903 43.6525 72.7848 45.7818 70.6918C46.9103 69.5823 47.0148 69.5117 47.2737 69.6807C48.6228 70.5617 50.4785 71.3768 52.1608 71.8271L53.2963 72.1312L53.3631 74.1677C53.4521 76.8792 53.2443 76.7143 56.5692 76.7143C59.894 76.7143 59.6863 76.8792 59.7752 74.1677L59.842 72.1312L60.9815 71.829C62.5144 71.4225 63.6662 70.948 65.059 70.1494L66.2216 69.4828L67.6714 70.9115C69.5383 72.7513 69.3924 72.7672 71.6932 70.473C74.0108 68.1618 74.0065 68.2247 71.9865 66.1605L70.7442 64.891L71.201 64.1567C71.8745 63.0744 72.6833 61.1644 73.0433 59.8069L73.3599 58.6133L75.3965 58.5465C78.108 58.4575 77.943 58.6652 77.943 55.3404C77.943 52.0156 78.108 52.2233 75.3965 52.1343L73.3599 52.0675L73.0461 50.8846C72.6744 49.4824 71.9992 47.8797 71.247 46.6135L70.7026 45.6972L72.1359 44.2427C73.9822 42.3691 73.9983 42.517 71.6954 40.2141C69.3932 37.9119 69.5398 37.9281 67.6714 39.7693L66.2216 41.198L65.059 40.5314C63.6662 39.7328 62.5144 39.2583 60.9815 38.8518L59.842 38.5496L59.7752 36.5131C59.6863 33.8016 59.894 33.9665 56.5692 33.9665C54.2998 33.9665 54.0305 33.9909 53.7453 34.2216ZM78.7755 43.3533C76.9549 45.1802 76.9552 45.1643 78.7077 46.9481C79.4221 47.6752 80.1445 48.3048 80.3133 48.3471C81.2552 48.5836 82.0225 47.468 81.4653 46.6725C81.2473 46.3612 81.2474 46.3611 81.6991 46.4588C86.3387 47.4612 89.7502 51.4142 90.1746 56.279C90.322 57.9687 91.0811 58.5204 91.9977 57.6039C92.4056 57.1959 92.4059 57.195 92.3159 56.0862C91.8666 50.5485 88.2645 46.1297 82.9421 44.5873C82.3069 44.4033 81.6136 44.2527 81.4013 44.2527C80.9304 44.2527 80.9253 44.1981 81.3495 43.6941C81.772 43.1919 81.774 42.7281 81.3555 42.3097C80.7017 41.6558 80.3088 41.8148 78.7755 43.3533ZM58.278 46.9991C64.9103 48.3402 67.3695 56.5515 62.5748 61.3461C57.7803 66.1408 49.569 63.6816 48.2279 57.0492C47.012 51.0361 52.2649 45.7832 58.278 46.9991ZM54.9811 49.1394C50.1372 50.442 48.5494 56.4937 52.1504 59.9283C55.7336 63.3461 61.5271 61.6691 62.782 56.8509C63.9717 52.2835 59.5484 47.9111 54.9811 49.1394ZM80.329 68.4197C80.0562 68.6402 80.0045 68.8237 79.9468 69.7772L79.88 70.8797L79.0117 71.1724C78.5341 71.3334 77.8199 71.6293 77.4243 71.8299L76.7052 72.1949L76.0206 71.5188C74.8794 70.3917 74.703 70.4182 73.1751 71.9463C71.647 73.4743 71.6205 73.6506 72.7476 74.7918L73.4237 75.4765L73.0587 76.1956C72.8581 76.5911 72.5622 77.3054 72.4012 77.783L72.1085 78.6513L71.006 78.7181C69.464 78.8114 69.3935 78.9108 69.3935 80.989C69.3935 83.0672 69.464 83.1666 71.006 83.26L72.1085 83.3268L72.4012 84.1951C72.5622 84.6727 72.8581 85.387 73.0587 85.7825L73.4237 86.5016L72.7476 87.1863C71.6359 88.3119 71.66 88.4997 73.1048 89.9681C74.636 91.5241 74.895 91.5708 75.9904 90.4892L76.7052 89.7832L77.4243 90.1481C77.8199 90.3488 78.5341 90.6447 79.0117 90.8057L79.88 91.0983L79.9468 92.2008C80.0402 93.7428 80.1396 93.8134 82.2178 93.8134C84.296 93.8134 84.3954 93.7428 84.4888 92.2008L84.5556 91.0983L85.4239 90.8057C85.9015 90.6447 86.6157 90.3488 87.0113 90.1481L87.7304 89.7832L88.415 90.4593C89.5562 91.5863 89.7326 91.5599 91.2605 90.0318C92.7886 88.5038 92.8151 88.3275 91.688 87.1863L91.0119 86.5016L91.3769 85.7825C91.5775 85.387 91.8734 84.6727 92.0344 84.1951L92.3271 83.3268L93.4296 83.26C94.9716 83.1666 95.0421 83.0672 95.0421 80.989C95.0421 78.9108 94.9716 78.8114 93.4296 78.7181L92.3271 78.6513L92.0344 77.783C91.8734 77.3054 91.5775 76.5911 91.3769 76.1956L91.0119 75.4765L91.688 74.7918C92.7997 73.6662 92.7756 73.4784 91.3308 72.01C89.7996 70.454 89.5406 70.4072 88.4452 71.4889L87.7304 72.1949L87.0113 71.8299C86.6157 71.6293 85.9015 71.3334 85.4239 71.1724L84.5556 70.8797L84.4888 69.7772C84.3954 68.2353 84.296 68.1647 82.2178 68.1647C80.8687 68.1647 80.5994 68.2011 80.329 68.4197ZM44.0728 75.9735C43.6744 76.3717 43.6402 77.1483 43.9442 78.8911C44.8405 84.0313 48.9068 88.2316 53.9823 89.2602L55.0691 89.4805L54.7504 89.8509C54.054 90.6607 54.7786 91.8861 55.802 91.6292C56.3952 91.4804 58.7066 88.9663 58.7066 88.4699C58.7066 87.9735 56.3952 85.4594 55.802 85.3106C54.8601 85.0741 54.0927 86.1897 54.6501 86.9853C54.8563 87.28 54.8546 87.293 54.6167 87.2234C54.4783 87.1831 54.0945 87.0802 53.7638 86.9951C49.3762 85.865 45.9198 81.4535 45.8869 76.942C45.8812 76.1559 45.4586 75.6456 44.8135 75.6456C44.5533 75.6456 44.2795 75.7667 44.0728 75.9735ZM84.4892 76.129C87.8272 77.6921 88.6091 82.163 86.0004 84.7717C83.9357 86.8364 80.4782 86.8428 78.4211 84.7857C76.5353 82.8999 76.363 79.6961 78.0336 77.5832C79.4703 75.7663 82.3359 75.1207 84.4892 76.129ZM80.7791 78.0585C78.536 79.1963 78.3657 82.2497 80.463 83.7238C80.9984 84.1001 81.1209 84.1283 82.2178 84.1283C83.3147 84.1283 83.4372 84.1001 83.9726 83.7238C85.0444 82.9705 85.3571 82.3528 85.3571 80.989C85.3571 79.6254 85.0444 79.0076 83.9733 78.2548C83.1896 77.704 81.6629 77.6102 80.7791 78.0585Z"
                      fill="#FCFFFE"
                      fill-opacity="0.8"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_b_1_133"
                      x="2.83533"
                      y="2.72559"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_133"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_133"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_1_133">
                      <rect
                        width="59.8488"
                        height="59.8488"
                        fill="white"
                        transform="translate(34.1711 33.7656)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div className="max_width mt-5">
                  <h2 className=" fw-semibold fs_md ff_Montserrat h2_text   text-lg-end">
                    Vertrieb skalieren
                  </h2>
                  <p className="fw-normal fs_sm ff_Montserrat text-light max_width text-lg-end">
                    Gewinne verlässlich und berechenbar Neukunden, während du
                    dich auf dein Tagesgeschäft konzentrieren kannst!
                  </p>
                </div>
                <svg
                  className=" svg_hover d-none d-lg-inline-block"
                  width="128"
                  height="127"
                  viewBox="0 0 128 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_133)">
                    <circle
                      cx="63.8353"
                      cy="63.7256"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <g clip-path="url(#clip0_1_133)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M53.7453 34.2216C53.4448 34.4644 53.4267 34.5732 53.3631 36.5131L53.2963 38.5496L52.1608 38.8521C50.7555 39.2262 49.0802 39.9272 47.8635 40.65L46.9389 41.1993L45.776 40.0099C43.7036 37.89 43.7593 37.8873 41.4366 40.2164C39.1424 42.5172 39.1583 42.3713 40.998 44.2382L42.4267 45.688L41.7601 46.8506C40.9616 48.2433 40.4871 49.3951 40.0806 50.928L39.7784 52.0675L37.7419 52.1343C35.0303 52.2233 35.1953 52.0156 35.1953 55.3404C35.1953 58.6652 35.0303 58.4575 37.7419 58.5465L39.7784 58.6133L40.0922 59.7962C40.464 61.1984 41.1391 62.8011 41.8913 64.0674L42.4357 64.9836L41.0024 66.4381C39.1576 68.3103 39.1417 68.163 41.4366 70.4644C43.7561 72.7903 43.6525 72.7848 45.7818 70.6918C46.9103 69.5823 47.0148 69.5117 47.2737 69.6807C48.6228 70.5617 50.4785 71.3768 52.1608 71.8271L53.2963 72.1312L53.3631 74.1677C53.4521 76.8792 53.2443 76.7143 56.5692 76.7143C59.894 76.7143 59.6863 76.8792 59.7752 74.1677L59.842 72.1312L60.9815 71.829C62.5144 71.4225 63.6662 70.948 65.059 70.1494L66.2216 69.4828L67.6714 70.9115C69.5383 72.7513 69.3924 72.7672 71.6932 70.473C74.0108 68.1618 74.0065 68.2247 71.9865 66.1605L70.7442 64.891L71.201 64.1567C71.8745 63.0744 72.6833 61.1644 73.0433 59.8069L73.3599 58.6133L75.3965 58.5465C78.108 58.4575 77.943 58.6652 77.943 55.3404C77.943 52.0156 78.108 52.2233 75.3965 52.1343L73.3599 52.0675L73.0461 50.8846C72.6744 49.4824 71.9992 47.8797 71.247 46.6135L70.7026 45.6972L72.1359 44.2427C73.9822 42.3691 73.9983 42.517 71.6954 40.2141C69.3932 37.9119 69.5398 37.9281 67.6714 39.7693L66.2216 41.198L65.059 40.5314C63.6662 39.7328 62.5144 39.2583 60.9815 38.8518L59.842 38.5496L59.7752 36.5131C59.6863 33.8016 59.894 33.9665 56.5692 33.9665C54.2998 33.9665 54.0305 33.9909 53.7453 34.2216ZM78.7755 43.3533C76.9549 45.1802 76.9552 45.1643 78.7077 46.9481C79.4221 47.6752 80.1445 48.3048 80.3133 48.3471C81.2552 48.5836 82.0225 47.468 81.4653 46.6725C81.2473 46.3612 81.2474 46.3611 81.6991 46.4588C86.3387 47.4612 89.7502 51.4142 90.1746 56.279C90.322 57.9687 91.0811 58.5204 91.9977 57.6039C92.4056 57.1959 92.4059 57.195 92.3159 56.0862C91.8666 50.5485 88.2645 46.1297 82.9421 44.5873C82.3069 44.4033 81.6136 44.2527 81.4013 44.2527C80.9304 44.2527 80.9253 44.1981 81.3495 43.6941C81.772 43.1919 81.774 42.7281 81.3555 42.3097C80.7017 41.6558 80.3088 41.8148 78.7755 43.3533ZM58.278 46.9991C64.9103 48.3402 67.3695 56.5515 62.5748 61.3461C57.7803 66.1408 49.569 63.6816 48.2279 57.0492C47.012 51.0361 52.2649 45.7832 58.278 46.9991ZM54.9811 49.1394C50.1372 50.442 48.5494 56.4937 52.1504 59.9283C55.7336 63.3461 61.5271 61.6691 62.782 56.8509C63.9717 52.2835 59.5484 47.9111 54.9811 49.1394ZM80.329 68.4197C80.0562 68.6402 80.0045 68.8237 79.9468 69.7772L79.88 70.8797L79.0117 71.1724C78.5341 71.3334 77.8199 71.6293 77.4243 71.8299L76.7052 72.1949L76.0206 71.5188C74.8794 70.3917 74.703 70.4182 73.1751 71.9463C71.647 73.4743 71.6205 73.6506 72.7476 74.7918L73.4237 75.4765L73.0587 76.1956C72.8581 76.5911 72.5622 77.3054 72.4012 77.783L72.1085 78.6513L71.006 78.7181C69.464 78.8114 69.3935 78.9108 69.3935 80.989C69.3935 83.0672 69.464 83.1666 71.006 83.26L72.1085 83.3268L72.4012 84.1951C72.5622 84.6727 72.8581 85.387 73.0587 85.7825L73.4237 86.5016L72.7476 87.1863C71.6359 88.3119 71.66 88.4997 73.1048 89.9681C74.636 91.5241 74.895 91.5708 75.9904 90.4892L76.7052 89.7832L77.4243 90.1481C77.8199 90.3488 78.5341 90.6447 79.0117 90.8057L79.88 91.0983L79.9468 92.2008C80.0402 93.7428 80.1396 93.8134 82.2178 93.8134C84.296 93.8134 84.3954 93.7428 84.4888 92.2008L84.5556 91.0983L85.4239 90.8057C85.9015 90.6447 86.6157 90.3488 87.0113 90.1481L87.7304 89.7832L88.415 90.4593C89.5562 91.5863 89.7326 91.5599 91.2605 90.0318C92.7886 88.5038 92.8151 88.3275 91.688 87.1863L91.0119 86.5016L91.3769 85.7825C91.5775 85.387 91.8734 84.6727 92.0344 84.1951L92.3271 83.3268L93.4296 83.26C94.9716 83.1666 95.0421 83.0672 95.0421 80.989C95.0421 78.9108 94.9716 78.8114 93.4296 78.7181L92.3271 78.6513L92.0344 77.783C91.8734 77.3054 91.5775 76.5911 91.3769 76.1956L91.0119 75.4765L91.688 74.7918C92.7997 73.6662 92.7756 73.4784 91.3308 72.01C89.7996 70.454 89.5406 70.4072 88.4452 71.4889L87.7304 72.1949L87.0113 71.8299C86.6157 71.6293 85.9015 71.3334 85.4239 71.1724L84.5556 70.8797L84.4888 69.7772C84.3954 68.2353 84.296 68.1647 82.2178 68.1647C80.8687 68.1647 80.5994 68.2011 80.329 68.4197ZM44.0728 75.9735C43.6744 76.3717 43.6402 77.1483 43.9442 78.8911C44.8405 84.0313 48.9068 88.2316 53.9823 89.2602L55.0691 89.4805L54.7504 89.8509C54.054 90.6607 54.7786 91.8861 55.802 91.6292C56.3952 91.4804 58.7066 88.9663 58.7066 88.4699C58.7066 87.9735 56.3952 85.4594 55.802 85.3106C54.8601 85.0741 54.0927 86.1897 54.6501 86.9853C54.8563 87.28 54.8546 87.293 54.6167 87.2234C54.4783 87.1831 54.0945 87.0802 53.7638 86.9951C49.3762 85.865 45.9198 81.4535 45.8869 76.942C45.8812 76.1559 45.4586 75.6456 44.8135 75.6456C44.5533 75.6456 44.2795 75.7667 44.0728 75.9735ZM84.4892 76.129C87.8272 77.6921 88.6091 82.163 86.0004 84.7717C83.9357 86.8364 80.4782 86.8428 78.4211 84.7857C76.5353 82.8999 76.363 79.6961 78.0336 77.5832C79.4703 75.7663 82.3359 75.1207 84.4892 76.129ZM80.7791 78.0585C78.536 79.1963 78.3657 82.2497 80.463 83.7238C80.9984 84.1001 81.1209 84.1283 82.2178 84.1283C83.3147 84.1283 83.4372 84.1001 83.9726 83.7238C85.0444 82.9705 85.3571 82.3528 85.3571 80.989C85.3571 79.6254 85.0444 79.0076 83.9733 78.2548C83.1896 77.704 81.6629 77.6102 80.7791 78.0585Z"
                      fill="#FCFFFE"
                      fill-opacity="0.8"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_b_1_133"
                      x="2.83533"
                      y="2.72559"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_133"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_133"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_1_133">
                      <rect
                        width="59.8488"
                        height="59.8488"
                        fill="white"
                        transform="translate(34.1711 33.7656)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div
              data-aos="fade-left"
              data-aos-offset="500"
              data-aos-duration="500"
              className="Prozesse_setup "
            >
              <div className=" d-flex  hover_text">
                <svg
                  className="svg_hover"
                  width="128"
                  height="127"
                  viewBox="0 0 128 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_140)">
                    <circle
                      cx="64.017"
                      cy="63.739"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M46.0364 37.5828L47.9505 40.1305L47.6452 40.3544C38.1395 47.3294 33.7196 59.1211 36.396 70.3664C39.1771 82.0521 48.7264 90.5558 60.895 92.1829L62.0432 92.3364L62.1495 91.934C62.8602 89.2409 64.4977 82.4818 64.4558 82.4141C64.4257 82.3654 63.9334 82.2913 63.3617 82.2494C56.2596 81.729 50.3485 77.7377 47.4215 71.4863C44.3309 64.8857 45.5847 56.7392 50.5249 51.3225C51.7185 50.0136 53.9012 48.1338 54.0522 48.2847C54.0746 48.3071 55.047 49.5977 56.2129 51.1527L58.3331 53.98L58.4467 53.5503C58.6839 52.6541 63.0503 35.1466 63.0503 35.0923C63.0503 35.0608 58.7915 35.0352 53.5863 35.0352H44.1225L46.0364 37.5828ZM66.4148 35.4727C65.7041 38.1657 64.0666 44.9249 64.1085 44.9925C64.1386 45.0412 64.6309 45.1154 65.2025 45.1573C70.6545 45.5568 75.2175 47.8859 78.6102 52.0009C83.9229 58.445 84.2561 67.639 79.4236 74.4491C78.2743 76.0688 74.7881 79.3979 74.521 79.1308C74.4937 79.1035 73.5173 77.809 72.3513 76.2539L70.2312 73.4266L70.1176 73.8563C69.8804 74.7526 65.514 92.2601 65.514 92.3144C65.514 92.3458 69.7731 92.3715 74.9786 92.3715H84.4434L82.6153 89.9358C81.6099 88.5963 80.7538 87.4444 80.7129 87.3762C80.6692 87.3034 81.0646 86.9365 81.6711 86.487C83.7754 84.9275 86.8503 81.5966 88.3857 79.2132C92.6811 72.5457 93.9943 64.534 92.0569 56.8162C89.1625 45.2863 79.5791 36.8007 67.6692 35.2224L66.5211 35.0702L66.4148 35.4727ZM62.8656 52.2699C58.098 53.6343 58.098 60.5868 62.8656 61.9176C63.5097 62.0975 63.5325 62.1147 63.2183 62.185C61.264 62.622 60.6683 62.8515 59.5934 63.5814C57.156 65.2366 55.8833 67.7736 55.8833 70.9776V72.2142H64.2821H72.681V70.9776C72.681 66.734 70.1527 63.3007 66.381 62.4228C65.9965 62.3333 65.5308 62.2248 65.346 62.1817L65.01 62.1033L65.4358 62.008C66.2555 61.8244 67.1313 61.3182 67.8164 60.6318C71.4837 56.9573 67.8619 50.8401 62.8656 52.2699Z"
                    fill="#FCFFFE"
                    fill-opacity="0.8"
                  />
                  <defs>
                    <filter
                      id="filter0_b_1_140"
                      x="3.01697"
                      y="2.73901"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_140"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_140"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>

                <div className="max_width mt-5">
                  <h2 className=" fw-semibold fs_md ff_Montserrat h2_text  text-start">
                    Prozesse automatisieren
                  </h2>
                  <p className=" fw-normal fs_sm ff_Montserrat text-light max_width text-start">
                    Gewinne verlässlich und berechenbar Neukunden, während du
                    dich auf dein Tagesgeschäft konzentrieren kannst!
                  </p>
                </div>
              </div>
            </div>
            <div
              data-aos="fade-left"
              data-aos-anchor="#example-anchor"
              data-aos-offset="500"
              data-aos-duration="500"
              className="Team_setup "
            >
              <div className=" d-flex hover_text">
                <svg
                  className=" svg_hover"
                  width="128"
                  height="127"
                  viewBox="0 0 128 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_1_147)">
                    <circle
                      cx="64.4896"
                      cy="63.7966"
                      r="50"
                      fill="#FCFFFE"
                      fill-opacity="0.12"
                    />
                  </g>
                  <g clip-path="url(#clip0_1_147)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M79.2611 34.1226C78.6671 34.4574 77.7352 34.6453 75.2547 34.93C71.4639 35.3654 69.9738 35.7487 68.3309 36.7117C64.8111 38.7745 63.6913 43.1961 65.7681 46.8306C66.6239 48.3283 67.7566 48.1216 67.9243 46.437C68.2617 43.048 70.0618 40.3091 72.888 38.8846C73.492 38.5802 73.4967 38.6025 72.9786 39.3235C70.215 43.1703 68.7818 49.8913 68.3445 61.0545C68.2308 63.9597 68.2701 64.2654 68.8397 64.9142C69.4736 65.6362 70.2735 65.8324 71.128 65.4752C71.7686 65.2076 72.0679 64.8774 72.5675 63.887C73.0841 62.8628 73.6359 62.0951 74.4792 61.2268L75.074 60.6145L75.571 61.0726C77.3702 62.7311 80.3174 62.9642 82.3582 61.6096C83.3291 60.9653 84.1693 59.9789 85.7062 57.6798C86.4581 56.5552 87.1241 55.5666 87.1865 55.4828C87.2488 55.399 87.2752 55.3141 87.2453 55.294C86.077 54.5134 84.9729 53.7255 84.1363 53.075C81.3432 50.9039 78.7778 50.494 76.4649 51.8494C74.5375 52.9791 73.1751 55.6783 74.5368 55.6697C74.7122 55.6685 75.2522 55.5603 75.7368 55.4291C76.7438 55.1565 79.1349 55.0057 80.3646 55.1374C81.3492 55.2428 81.3108 55.2898 80.1176 55.4395C77.2542 55.7985 74.5609 57.1022 72.5943 59.0812L71.7426 59.9382L71.7431 59.1265C71.7439 57.6748 72.137 52.998 72.4233 51.0328L72.5087 50.4469L73.1536 50.3552C75.0573 50.0843 77.2675 48.3363 78.5581 46.0806C80.0635 43.4497 80.4915 40.4558 79.9584 36.2855C79.6572 33.9295 79.6491 33.904 79.2611 34.1226ZM59.7602 51.2495C58.2499 51.6125 57.6422 51.9476 55.3094 53.7046C54.3798 54.4046 53.4621 55.0587 53.2701 55.158L52.9211 55.3385L53.215 55.652C53.3767 55.8243 53.9364 56.6419 54.4587 57.4688C56.8872 61.3129 58.4025 62.4879 60.9269 62.4839C64.349 62.4785 66.9361 59.6299 65.2564 57.7168C64.4648 56.8153 61.6517 55.7096 59.4077 55.4178C58.3794 55.2842 58.3286 55.2658 58.7616 55.1839C60.2792 54.8968 63.1305 55.1318 64.7765 55.6796C66.6038 56.2876 66.9274 55.4047 65.6037 53.4224C64.4131 51.6394 61.9494 50.7233 59.7602 51.2495ZM54.0039 66.1938C52.9785 66.3787 51.4946 66.8571 50.6558 67.2732C48.8764 68.1557 48.7147 68.3012 40.3572 76.5337L35.8148 81.0081L42.254 87.4464L48.693 93.8846L50.8175 90.7012L52.9419 87.5178L63.7813 87.4793C73.4197 87.4451 74.6926 87.4195 75.2687 87.2479C76.5555 86.8647 77.2917 86.5359 78.122 85.9735C79.0246 85.3623 95.2465 70.9818 95.6299 70.4529C96.7213 68.9481 95.0374 67.1657 92.5242 67.1657C90.4698 67.1657 90.274 67.2808 81.8903 73.416L74.5549 78.784L70.2552 78.8711L65.9553 78.9581L64.8263 77.8289L63.6971 76.6998L68.0429 76.6984C71.4337 76.6973 72.5274 76.6601 73.0195 76.5291C77.1713 75.4241 77.9198 70.6228 74.2292 68.769C73.1273 68.2156 72.352 68.1287 68.4533 68.122C64.2694 68.1148 63.6499 68.0346 61.8503 67.2658C59.113 66.0965 56.513 65.7413 54.0039 66.1938Z"
                      fill="#FCFFFE"
                      fill-opacity="0.8"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_b_1_147"
                      x="3.48962"
                      y="2.79663"
                      width="122"
                      height="122"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="5.5"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1_147"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1_147"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_1_147">
                      <rect
                        width="59.8488"
                        height="59.8488"
                        fill="white"
                        transform="translate(34.8254 33.8369)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <div className="max_width mt-5 mt-lg-0">
                  <h2 className=" fw-semibold fs_md ff_Montserrat h2_text  text-start">
                    Team aufbauen
                  </h2>
                  <p className=" fw-normal fs_sm ff_Montserrat text-light max_width text-start">
                    Baue dein A-Team aus Top-Talenten, die zukünftiges Wachstum
                    schultern und Umsatzrekorde mit dir brechen!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Zusammenarbeit;
